module.exports = __webpack_public_path__ + "static/img/blink-logo.509dd025.png";